/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { fabric, LayerManager, eventStatus } from '@aibee/vincent';

// 连接线
const CommonLine = fabric.util.createClass(fabric.Line, {

  type: 'CommonLine',
  rels: [],
  property: {},
  initialize(options) {
    this.initParams(options);
    const { shapeParams = {} } = options;
    this.graphic_data = shapeParams.graphic_data;
    shapeParams.stroke = 'red';
    shapeParams.selectable = true;
    shapeParams.lockMovementX = true;
    shapeParams.lockMovementY = true;
    shapeParams.objectCaching = false;
    this.callSuper('initialize', this.graphic_data, shapeParams);
    this.initEvents();
    this.initGraphic(shapeParams);
  },
  initGraphic(shapeParams) {
    const { x: x1, y: y1 } = this.graphic_data[0];
    this.startPoint = this.graphic_data[0];
    if (this.graphic_data[1]) {
      const { x: x2, y: y2 } = this.graphic_data[1];
      this.callSuper('initialize', [x1, y1, x2, y2], shapeParams);
    } else {
      this.callSuper('initialize', [x1, y1, x1, y1], shapeParams);
      eventStatus.currentDrawingObject = this;
    }
  },
  addPoint(pointXY) {
    if (this.graphic_data.length >= 2) return;
    const { x, y } = pointXY;
    this.set('x2', x).set('y2', y).setCoords();
    this.graphic_data.push(pointXY);
    eventStatus.currentDrawingObject = null;
  },
  setAssistantLine({ x, y }) {
    this.set('x2', x).set('y2', y).setCoords();
    LayerManager.getCurrentLayer().canvas.renderAll();
  },
  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      property: this.property,
    });
  },

  _render(ctx) {
    this.ctx = ctx;
    this.callSuper('_render', ctx);
    if (this.config && this.config.property && this.config.property.path_direction) {
      this.drawArrow(ctx, [this.x1, this.y1], [this.x2, this.y2], this.config.property.path_direction);
    }
  },

  // 画方向箭头
  drawArrow(ctx, sta, end, fx) {
    ctx.save();
    ctx.beginPath();
    let ang = (end[0] - sta[0]) / (end[1] - sta[1]);
    ang = Math.atan(ang);
    if (fx === 'backward' || fx === 'twoward' || fx === 'backward_direction') {
      if (end[1] - sta[1] < 0) {
        ctx.rotate(-ang);
      } else {
        ctx.rotate(Math.PI - ang);// 加个180度，反过来
      }
    } else if (end[1] - sta[1] >= 0) { // forward
      ctx.rotate(-ang);
    } else {
      ctx.rotate(Math.PI - ang);// 加个180度，反过来
    }
    ctx.lineTo(-5, -10);
    ctx.lineTo(0, -5);
    ctx.lineTo(5, -10);
    ctx.lineTo(0, 0);
    ctx.fillStyle = 'darkred';
    ctx.fill(); // 箭头是个封闭图形
    ctx.closePath();
    ctx.restore();
    if (fx === 'twoward') {
      // 双向通行再画一次正向箭头
      this.drawArrow(ctx, sta, end, 'forword');
    }
  },

  setFrom(obj) {
    this.rels[0] = obj;
    return this;
  },

  setTo(obj) {
    this.rels[1] = obj;
    return this;
  },

  getFrom() {
    return this.rels[0];
  },

  getTo() {
    return this.rels[1];
  },
});

Object.defineProperty(fabric, 'CommonLine', {
  writable: false,
  value: CommonLine,
});
